import { render, staticRenderFns } from "./DrinkingAgeModal.vue?vue&type=template&id=62252fdc&scoped=true&"
import script from "./DrinkingAgeModal.vue?vue&type=script&lang=ts&"
export * from "./DrinkingAgeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62252fdc",
  null
  
)

export default component.exports